import "./HeroBanner.css";
import Banner1 from "../../assets/images/Banner1.png";
import Banner2 from "../.././assets/images/Banner2.png";
import Banner3 from "../.././assets/images/Banner3.png";
import { Carousel } from "antd";
export default function HeroBanner() {
  return (
    <Carousel autoplay>
      <img src={Banner1} alt="Bear Bitz Banner 1" className="contentStyle" />

      <img src={Banner2} alt="Bear Bitz Banner 2" className="contentStyle" />

      <img src={Banner3} alt="Bear Bitz Banner 3" className="contentStyle" />
    </Carousel>
  );
}
